import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuCss = ":host{display:block;border-radius:8px;background:#ffffff;box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.20);backdrop-filter:blur(13.5px);padding:8px 0}";

const MapyMapmenu$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenu extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
  static get style() { return mapyMapmenuCss; }
}, [1, "mapy-mapmenu"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenu$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenu = MapyMapmenu$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenu, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu.js.map